module.exports = __webpack_public_path__ + "static/media/icon_remover_item_carrinho.71445392.svg";